import styled from "styled-components";
import FSendTopBar from "./FSendTopBar";
import { useEffect } from "react";
import { useTheme } from "../context/ThemeContext";
import { THEME_SYSTEM, THEME_LIGHT, THEME_DARK } from "../context/ThemeContext";
import { useUser } from "./provider/UserAuthProvider";

const Layout = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: var(--system-grouped-background);
  min-height: 100vh;
`;

function MainLayout({ topBarShowBottomLine = false, children }) {
  const { theme } = useTheme();
  const use = useUser();

  useEffect(() => {
    const applyTheme = (theme) => {
      let isDarkMode;
      if (theme === THEME_SYSTEM) {
        isDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;
        if (isDarkMode) {
          document.documentElement.setAttribute("data-theme", THEME_DARK);
        } else {
          document.documentElement.setAttribute("data-theme", THEME_LIGHT);
        }
      } else {
        isDarkMode = theme === THEME_DARK;
        document.documentElement.setAttribute("data-theme", theme);
      }

      // Update meta theme-color
      const metaThemeColor = document.querySelector("meta[name='theme-color']");
      if (metaThemeColor) {
        // Remove media attribute to force the color when controlled by JS
        const metaTags = document.querySelectorAll("meta[name='theme-color']");
        metaTags.forEach((tag) => {
          tag.remove();
        });
        const meta = document.createElement("meta");
        meta.name = "theme-color";
        meta.content = isDarkMode ? "#000000" : "#f2f2f7";
        document.head.appendChild(meta);
      }
    };
    applyTheme(theme);

    if (theme === THEME_SYSTEM) {
      // 监听系统主题变化
      const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
      const handleChange = () => applyTheme("system");
      mediaQuery.addEventListener("change", handleChange);

      return () => mediaQuery.removeEventListener("change", handleChange);
    }
  }, [theme]);
  return (
    <Layout>
      <FSendTopBar topBarShowBottomLine={topBarShowBottomLine} />
      {children}
    </Layout>
  );
}

export default MainLayout;
